export const Cross = ({ size = 32, className }: { size?: number; className?: string }) => {
	return (
		<svg
			width={size}
			height={size}
			className={className}
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M22 10L10 22M22 22L10 10" stroke="#0E0E0E" strokeWidth="2" strokeLinecap="round" />
		</svg>
	);
};
